import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_BASE_HREF } from '@angular/common';

@Injectable({
    providedIn: 'root'
  })
export class ApiInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_BASE_HREF) private readonly baseHref: string) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith('/api/')) {
      return next.handle(req);
    }

    const apiReq = req.clone({ url: `${this.baseHref}${req.url}` });
    return next.handle(apiReq);
  }
}
